module.exports = __webpack_public_path__ + "src/img/artist/work08_1.jpg?7c2e8ed2dece13c36bf4a747ecd6acc1";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/work08_1.jpg
// module id = 25
// module chunks = 0